(function () {
  function init(root) {
    if (!root || root.dataset.alvoraReady === 'true') return;
    root.dataset.alvoraReady = 'true';

    const menu = root.querySelector('.alvora-menu');
    const nav = root.querySelector('.alvora-nav');
    if (menu && nav) {
      menu.addEventListener('click', function () {
        const open = nav.classList.toggle('is-open');
        menu.setAttribute('aria-expanded', String(open));
      });
      nav.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () {
          nav.classList.remove('is-open');
          menu.setAttribute('aria-expanded', 'false');
        });
      });
    }

    root.querySelectorAll('[data-alvora-qty]').forEach(function (box) {
      const input = box.querySelector('input');
      const minus = box.querySelector('[data-minus]');
      const plus = box.querySelector('[data-plus]');
      if (!input) return;
      const change = function (delta) {
        const min = Number(input.min || 1);
        const max = Number(input.max || 99);
        input.value = Math.max(min, Math.min(max, Number(input.value || 1) + delta));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      };
      if (minus) minus.addEventListener('click', function () { change(-1); });
      if (plus) plus.addEventListener('click', function () { change(1); });
    });

    root.querySelectorAll('[data-alvora-gallery]').forEach(function (gallery) {
      const main = gallery.querySelector('[data-main-image]');
      const stage = gallery.querySelector('.alvora-main-image');
      const thumbs = Array.from(gallery.querySelectorAll('[data-thumb]'));
      const counter = gallery.querySelector('[data-gallery-count]');
      let current = Math.max(0, thumbs.findIndex(function (thumb) { return thumb.classList.contains('is-active'); }));

      const showImage = function (index) {
        if (!main || !thumbs.length) return;
        current = (index + thumbs.length) % thumbs.length;
        const thumb = thumbs[current];

        // İlk görselin responsive srcset'i sonraki görseli ezmesin.
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.src = thumb.dataset.src;
        main.alt = thumb.dataset.alt || '';

        thumbs.forEach(function (item, itemIndex) {
          const active = itemIndex === current;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-current', active ? 'true' : 'false');
        });
        if (counter) counter.textContent = (current + 1) + ' / ' + thumbs.length;
      };

      thumbs.forEach(function (thumb, index) {
        thumb.addEventListener('click', function () { showImage(index); });
      });

      const previous = gallery.querySelector('[data-gallery-prev]');
      const next = gallery.querySelector('[data-gallery-next]');
      if (previous) previous.addEventListener('click', function () { showImage(current - 1); });
      if (next) next.addEventListener('click', function () { showImage(current + 1); });

      if (stage) {
        stage.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowLeft') { event.preventDefault(); showImage(current - 1); }
          if (event.key === 'ArrowRight') { event.preventDefault(); showImage(current + 1); }
        });

        let startX = null;
        stage.addEventListener('pointerdown', function (event) {
          if (event.target.closest('button')) return;
          startX = event.clientX;
        });
        stage.addEventListener('pointerup', function (event) {
          if (startX === null) return;
          const distance = event.clientX - startX;
          startX = null;
          if (Math.abs(distance) < 45) return;
          showImage(current + (distance < 0 ? 1 : -1));
        });
        stage.addEventListener('pointercancel', function () { startX = null; });
      }

      showImage(current);
    });

    root.querySelectorAll('[data-buy-now]').forEach(function (button) {
      button.addEventListener('click', async function () {
        const form = button.closest('form');
        if (!form) return;
        button.disabled = true;
        try {
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: new FormData(form)
          });
          if (!response.ok) throw new Error('Ürün sepete eklenemedi.');
          window.location.href = '/checkout';
        } catch (error) {
          alert(error.message || 'İşlem tamamlanamadı. Lütfen tekrar deneyin.');
          button.disabled = false;
        }
      });
    });

    const discountButton = root.querySelector('[data-discount-button]');
    if (discountButton) {
      discountButton.addEventListener('click', function () {
        const input = root.querySelector('[data-discount-input]');
        const code = input ? input.value.trim() : '';
        if (!code) { if (input) input.focus(); return; }
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
      });
    }

    const trackingForm = root.querySelector('[data-tracking-form]');
    if (trackingForm) {
      trackingForm.addEventListener('submit', function (event) {
        event.preventDefault();
        const order = trackingForm.querySelector('[name="order_number"]').value.trim();
        const contact = trackingForm.querySelector('[name="contact"]').value.trim();
        const message = trackingForm.querySelector('[data-tracking-message]');
        if (!order || !contact) {
          if (message) message.textContent = 'Sipariş numarası ve iletişim bilgisini birlikte girin.';
          return;
        }
        const text = 'Merhaba ALVORA, ' + order + ' numaralı siparişimin kargo durumunu öğrenmek istiyorum. İletişim: ' + contact;
        window.open('https://wa.me/905532487433?text=' + encodeURIComponent(text), '_blank', 'noopener');
        if (message) message.textContent = 'WhatsApp destek ekranı açıldı.';
      });
    }
  }

  document.querySelectorAll('.alvora-shell').forEach(init);
  document.addEventListener('shopify:section:load', function (event) { init(event.target.querySelector('.alvora-shell')); });
})();

